import ClearIcon from '@mui/icons-material/Clear';
import { Typography, styled } from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useRef, useState } from 'react';
import { color } from 'theme';
import './index.css';
import { useTheme } from 'hooks';
import { convertSecondToHourAndMinute } from '../functions';

const arrayTime = Array.from(Array(96).keys()).map(item => convertSecondToHourAndMinute((item) * 900));

const filter = createFilterOptions();

const AutocompleteCC = styled(Autocomplete)({
    borderRadius: '6px',
    '& .MuiInputBase-root': {
        paddingRight: '0px !important',
        fontSize: '15px',
        borderRadius: '6px',
        "& input": {
            fontWeight: '500',
            paddingTop: '2px !important',
            paddingBottom: '2px !important',
            height: '24px'
        }
    },
    '& .MuiAutocomplete-clearIndicator': {
        display: 'none'
    },
    '& .MuiAutocomplete-listbox': {
        color: 'red'
    }
})


export const TimePickerCC = ({ value, setValue, validTime = true, id, disabled = false, minTime = null, maxTime = null }) => {
    const { primaryInitalColor } = useTheme()
    const [renderValue, setRenderValue] = useState(value);
    const options = arrayTime
    const refValue = useRef(value)
    const handleChangeValue = (value, changeValue = false) => {
        if (changeValue) {
            setValue(value);
            setRenderValue(value);
            refValue.current = value
        } else {
            setRenderValue(refValue.current)
        }
    }

    return (
        <AutocompleteCC
            className={disabled ? 'time-picker-disabled time-picker' : 'time-picker'}
            id={id}
            clearIcon={
                <ClearIcon fontSize="small" sx={{ display: 'none' }} />
            }
            disabled={disabled}
            openOnFocus={true}
            options={options}
            openText=""
            value={disabled ? 'HH:mm' : (renderValue || null)}
            onChange={(event, value) => {
                handleChangeValue(value, true)
            }}
            blurOnSelect
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const isExisting = options.some((option) => params.inputValue === option);
                if (params.inputValue !== '' && !isExisting) {
                    filtered.push(params.inputValue);
                }

                return filtered;
            }}
            renderOption={(props, option, { selected }) => {
                return <Typography {...props} p={1} sx={{
                    cursor: 'pointer', color: selected ? color.white : theme => theme.palette.text.primary, backgroundColor: selected ? `${primaryInitalColor} !important` : 'auto',
                    '&:hover': {
                        color: color.redP01,
                        backgroundColor: `${color.greyIL07} !important`
                    },
                }}>{option}</Typography>
            }}
            renderInput={(params) => <TextField error={!validTime} placeholder='hh:mm' sx={{ minWidth: '100px' }} {...params} />}
            getOptionDisabled={(option) => {
                if (minTime && option < minTime) {
                    return true
                }
                if (maxTime && option > maxTime) {
                    return true
                }
                return false
            }}
            sx={[
                {
                    '& .MuiButtonBase-root': {
                        marginRight: '0 !important' 
                    }
                }
            ]}
        />
    );
}


